import type { MergedOperation, SampleOperationResult } from './CSVModalTypes.js'

export function mapToBatches(
  result: SampleOperationResult,
): OpBatch[] {
  const undefKey = "undefined-key"
  const value: Record<string, Record<string, MergedOperation[]>> = {}
  result.result.forEach(x => {
    if (!value[x.orderId]) {
      value[x.orderId] = { }
    }
    if (!value[x.orderId][x.poolId ?? undefKey]) {
      value[x.orderId][x.poolId ?? undefKey] = []
    }
    value[x.orderId][x.poolId ?? undefKey].push(x)
  })
  return Object.entries(value)
    .flatMap(([orderId, v1]) =>
      Object.entries(v1).flatMap(([poolId, v2]) =>
        (
          {
            orderId: orderId,
            poolId: poolId === undefKey ? undefined: poolId,
            ops: v2
          }
        )
      )
    )
}

export type OpBatch = {
  orderId: string,
  poolId?: string,
  ops: MergedOperation[]
}